import {
  GET_MUNDIAL_SCHEDULE_RESULTS,
  GET_MUNDIAL_STRUCTURE,
} from './../types/calendar.types';

const initState = {
  structure: [],
  scheduleResults: {
    matches: [],
  },
};

export default (state = initState, action) => {
  switch (action.type) {
    case GET_MUNDIAL_STRUCTURE:
      return {
        ...state,
        structure: action.payload,
      };
    case GET_MUNDIAL_SCHEDULE_RESULTS:
      return {
        ...state,
        scheduleResults: {
          ...state.scheduleResults,
          matches: action.payload,
        },
      };

    default:
      return state;
  }
};
